<template>
  <div class="custom-badge">
    <div
      :style="{
        background: params.color,
        position: 'absolute',
        inset: 0,
        opacity: 0.2,
      }">
  
    </div>
    <i :class="[params.icon, params.icon ? 'mr-1': '']" class="darker-color" :style="{color: params.color}"></i>    
    <span :style="{color: params.color}" class="darker-color">{{ params.text || params.valueFormatted || params.value }}</span>
  </div>
</template>
<script>
export default {
  name: "AgBadge",
  data() {
    return {
      data: [],
    }
  },
  created() {
    this.data = this.params.data;
  },
};
</script>
<style scoped>

.custom-badge {
  position: relative;
  display: inline-block;
  padding: 1px 0.375rem;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 0.375rem;
  overflow: hidden;
}
.darker-color {
  filter: brightness(0.8) saturate(1.5); /* Ajusta el valor para oscurecer */
  line-height: 1;
}
</style>